import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useLastTerminatedInvoice() {
  const [invoice, setInvoice] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.members.terminated.lastTerminatedInvoice)
      .then((response) => {
        setInvoice(response.data.data);
      }).catch(() => {
        setInvoice({
          id: null,
        });
      });
  }, []);

  return invoice;
}
